export default {
  searching: 'Söker',
}
